//UserInterface to define the State type for the state of the reducer

import {
  GET_CLASSROOM_FAILED_CU,
  GET_CLASSROOM_SUCCESS_CU,
  GET_SERVICE_CENTER_FAILED_CU,
  GET_SERVICE_CENTER_SUCCESS_CU,
  GET_SITE_FAILED_CU,
  GET_SITE_SUCCESS_CU,
  GET_SUB_RECIPIENT_FAILED_CU,
  GET_SUB_RECIPIENT_SUCCESS_CU,
  RESET_CU_DATA,
} from "../actionConstants";

interface AppInterface {
  siteList: any;
  serviceCenterList: any;
  subRecipientList: any;
  classroomList: any;
}

interface Actions {
  payload: any;
  type: string;
  token: string;
}

//State type for defining the state of the reducer
export type State = AppInterface;

//Initial state of the reducer of type State
export const initialState: State = {
  siteList: [],
  serviceCenterList: [],
  subRecipientList: [],
  classroomList: [],
};

export const CUReducers = (state: State = initialState, action: Actions) => {
  switch (action.type) {
    //if action is of type SIGN_IN or SIGN_UP return the state by setting token to the payload
    case GET_SITE_SUCCESS_CU:
      return {
        ...state,
        siteList: action.payload.data,
      };
    case GET_SITE_FAILED_CU:
      return {
        ...state,
        userList: [],
      };
    case GET_SERVICE_CENTER_SUCCESS_CU:
      return {
        ...state,
        serviceCenterList: action.payload.data,
      };
    case GET_SERVICE_CENTER_FAILED_CU:
      return {
        ...state,
        serviceCenterList: [],
      };
    case GET_SUB_RECIPIENT_SUCCESS_CU:
      return {
        ...state,
        subRecipientList: action.payload.data,
      };
    case GET_SUB_RECIPIENT_FAILED_CU:
      return {
        ...state,
        subRecipientList: [],
      };
    case GET_CLASSROOM_SUCCESS_CU:
      return {
        ...state,
        classroomList: action.payload.data,
      };
    case GET_CLASSROOM_FAILED_CU:
      return {
        ...state,
        classroomList: [],
      };
    case RESET_CU_DATA:
      return {
        ...state,
        siteList: [],
        serviceCenterList: [],
        subRecipientList: [],
        classroomList: [],
      };
    default:
      return state;
  }
};
